import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import {User} from '@cp/model';
import AccountInfoAvatar from './AccountInfoAvatar';
import AccountInfoEmail from './AccountInfoEmail';

export interface AccountInfoProps {
  user: User;
}

export default function AccountInfo({user}: AccountInfoProps) {
  return (
    <Paper sx={{p: 3, mb: 3}}>
      <Typography variant="h6" gutterBottom>
        Account Information
      </Typography>

      <AccountInfoEmail user={user} />

      <AccountInfoAvatar user={user} />
    </Paper>
  );
}
